import React, { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { AlertModal } from '../components/common';

/**
 * window.alert() 대체 훅 — 공통 AlertModal 을 한 줄로 띄운다.
 * useAvailabilityCheck 와 동일하게 렌더링할 JSX(alertModal)를 함께 반환한다.
 *
 * 사용법:
 *   const { showAlert, alertModal } = useAlertModal();
 *   ...
 *   showAlert(t('payment.alert_payment_failed'));            // 오류(기본)
 *   showAlert(message, { variant: 'info', title });          // 안내
 *   ...
 *   return (<> ... {alertModal} </>);
 */
export default function useAlertModal() {
  const { t } = useTranslation();
  const [state, setState] = useState({ open: false, message: '', title: '', variant: 'error' });

  const showAlert = useCallback((message, opts = {}) => {
    setState({ open: true, message, title: opts.title || '', variant: opts.variant || 'error' });
  }, []);

  const close = useCallback(() => setState((p) => ({ ...p, open: false })), []);

  const alertModal = (
    <AlertModal
      open={state.open}
      onClose={close}
      title={state.title}
      message={state.message}
      variant={state.variant}
      confirmLabel={t('common.confirm')}
    />
  );

  return { showAlert, alertModal };
}
